import ModalWindow from '../modals/ModalWindow/ModalWindow';

const ModalsManager = () => {
  return (
    <>
      <ModalWindow modalName="camper_modal" />
      <ModalWindow modalName="images_modal" />
    </>
  );
};

export default ModalsManager;
